import { APP_LOCALE, formatDate } from '../../helpers/format.js';
import type { DataRecord, FieldValues, RecordRef } from '../../models/company-data.js';
import type { DataField } from './definition.js';

export function isRecordRef(value: unknown): value is RecordRef {
  return typeof value === 'object' && value !== null && typeof (value as RecordRef).recordId === 'string';
}

export function recordValues(record: Pick<DataRecord, 'fields' | 'privateFields'>): FieldValues {
  return { ...record.fields, ...record.privateFields };
}

export function formatCell(field: DataField, value: unknown, refTitles: Map<string, string>): string {
  if (value === undefined || value === null || value === '') return '';
  switch (field.kind) {
    case 'number':
      return typeof value === 'number' ? new Intl.NumberFormat(APP_LOCALE).format(value) : String(value);
    case 'yesNo':
      return value ? 'Yes' : 'No';
    case 'date':
      return formatDate(value as string, 'date');
    case 'reference':
      return isRecordRef(value) ? (refTitles.get(value.recordId) ?? 'Record not found') : '';
    default:
      return String(value);
  }
}

// The records a page's reference cells point at, so their titles can be fetched once
export function referencedRecordIds(
  fields: DataField[],
  records: Pick<DataRecord, 'fields' | 'privateFields'>[],
): string[] {
  const refFields = fields.filter((field) => field.kind === 'reference');
  const ids = records.flatMap((record) => {
    const values = recordValues(record);
    return refFields
      .map((field) => values[field.key])
      .filter(isRecordRef)
      .map((ref) => ref.recordId);
  });
  return [...new Set(ids)];
}
